import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CarregamentoService {
  public carregandoDados = new BehaviorSubject<boolean>(false);

  loading$ = this.carregandoDados.asObservable();

  constructor() {}

  startLoading(): void {
    this.carregandoDados.next(true);
  }

  finishLoading(): void {
    this.carregandoDados.next(false);
  }
}